import React from "react";
import { getLogoOptions } from "../../utils/notification";
import { BrandificationImageFallback } from "../../components";

const NotificationLogo = ({ notification, viewProfile, setReviewed }) => {
  let [image, fallbackImage, viewDetails] = getLogoOptions(notification, viewProfile, setReviewed);
  return image || fallbackImage ? (
    <BrandificationImageFallback
      onClick={viewDetails && viewDetails}
      src={image}
      fallbackImage={fallbackImage}
      className="notification-logo-div"
    />
  ) : (
    <div className="notification-logo-div no-image"></div>
  );
};

export default NotificationLogo;
